export default __webpack_public_path__ + "static/media/shadow.845fc525.png";